

var _squid = require('squid');

define(['squid/index', 'components/node-uuid/uuid'], function (squid, uuid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.marketingoffer', [// eslint-disable-line angular/no-service-method
    'squid']).factory('$MarketingOfferModel', function ($Model, $Api) {
        return $Model.extend('$MarketingOfferModel', {
            api: new $Api({
                uri: '/api/checkout/offer/search-ads',
                postAttempts: 1

            }),

            serialize: function serialize() {
                var data = {
                    'site': this.site,
                    'locale': this.locale,
                    'si': this.si,
                    'visit_id': uuid.v4(),
                    'page': this.page,
                    'epu': this.payer,
                    'pu_type': this.puType || 'ANONYMOUS',
                    'country_code': this.countryCode,
                    'payment_context': {
                        'total_transaction_amount': this.totalTransactionAmount,
                        'total_shipping_amount': this.totalShippingAmount,
                        'business_case': 'NONE',
                        'business_case_variation': '',
                        'validate_existing_offer': 'false',
                        'payment_units': [{
                            'transaction_amount': this.totalTransactionAmount,
                            'transaction_id': '',
                            'encrypted_transaction_id': '',
                            'activity_id': '',
                            'payee': {
                                'pu_type': 'BUSINESS',
                                'country_code': this.countryCode,
                                'epu': this.payee,
                                'pu': ''
                            }
                        }]
                    },
                    'target_placements': this.targetPlacements,
                    'wallet_instruments': this.walletInstruments,
                    'addl_property_installments_not_allowed': this.installmentsNotAllowed
                };

                return data;
            }
        });
    }).service('$fireMORSBeacon', function ($q) {
        this.fireBeacon = function (uri) {
            var img = document.createElement('img');

            img.setAttribute('src', uri);
            document.body.appendChild(img);

            return;
        };
    }).factory('$MemberSegmentModel', function ($Model, $Api) {
        return $Model.extend('$MemberSegmentModel', {
            api: new $Api({
                uri: '/api/segment/memberSegment',
                postAttempts: 1
            }),

            invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

            getMemberSegment: function getMemberSegment() {
                return this.memberSegment;
            },

            getCreditOffer: function getCreditOffer() {
                return this.creditOffer;
            },

            isNewMember: function isNewMember() {
                return this.memberSegment === 'NEW_MEMBER' || this.memberSegment === 'YOUNG_MEMBER';
            },

            // Member Segments that are eligble for the New Experience
            isEligibleForExperimentation: function isEligibleForExperimentation() {
                // Default to NEW/YOUNG member for backwards compatibility
                var eligibleMemberSegments = _squid.$config.memberSegments || ['NEW_MEMBER', 'YOUNG_MEMBER'];
                return eligibleMemberSegments.indexOf(this.memberSegment) > -1;
            }

        });
    });
});

_squid.$config;


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/marketingoffer/index.js
// module id = ./components/xo-models/src/marketingoffer/index.js
// module chunks = 1